import { Box, Tag, Typography } from "@luce/ui";

import { formatPackageAddress, getPackageStatusTag } from "../../lib";
import { usePackageDetailContext } from "../package-detail-context";

export function PackageDetailHeader() {
  const { packageDetail } = usePackageDetailContext();
  const statusTag = getPackageStatusTag(packageDetail.status);

  return (
    <Box className="gap-spacing-md p-spacing-lg flex flex-row items-start justify-between">
      <Box className="gap-spacing-xs flex flex-1 flex-col">
        <Typography variant="label-sm" color="neutral-foreground-default">
          {packageDetail.packageDescription}
        </Typography>
        <Typography variant="body-sm" color="neutral-foreground-intermediate">
          {formatPackageAddress(packageDetail)}
        </Typography>
      </Box>
      <Tag variant={statusTag.variant} size="sm" outline>
        {statusTag.label}
      </Tag>
    </Box>
  );
}
